import { Button, Icon } from 'semantic-ui-react';
import { getPreferenceOptions, getPreferenceQuestion } from 'src/containers/conexion/constants';
import OptionSelectList from 'src/components/OptionSelectList';

const GroupPreferenceSelect = ({
  gender,
  includeCouples = false,
  categoryInfo,
  groupPreference,
  preferenceError,
  onSelectPreference,
  onContinue,
  onBack,
}) => (
  <div className="group-preference-step">
    {onBack && (
      <Button className="selectGroup-back" type="button" onClick={onBack}>
        <Icon name="arrow left" /> Atrás
      </Button>
    )}

    <div className="selectGroup-header">
      <h2>Preferencia de Grupo</h2>
      <p className="selectGroup-intro">
        Adaptamos la búsqueda de acuerdo a tu perfil y rango de edad
        {categoryInfo ? ` (${categoryInfo.age} años • ${categoryInfo.categoryLabel})` : ''}.
      </p>
      <div className="group-preference-focus">
        <p className="group-preference-focus-label">Pregunta de enfoque</p>
        <p className="group-preference-focus-question">
          {getPreferenceQuestion(gender, { includeCouples })}
        </p>
      </div>
    </div>

    {preferenceError && (
      <p className="group-preference-error">Por favor selecciona una preferencia para continuar.</p>
    )}

    <div className="group-preference-options">
      <OptionSelectList
        options={getPreferenceOptions(gender, { includeCouples })}
        value={groupPreference}
        onChange={onSelectPreference}
        error={preferenceError}
        columns={1}
        indicator="check"
      />
    </div>

    <div className="group-preference-actions">
      <Button type="button" primary className="group-preference-submit" onClick={onContinue}>
        Buscar Grupos Disponibles <Icon name="chevron right" />
      </Button>
    </div>
  </div>
);

export default GroupPreferenceSelect;
